import React, { Component } from 'react';
import classnames from 'classnames';
import NumberFormat from 'react-number-format';
import { Field, getIn } from 'formik';
import 'shared/components/text-field/TextField.scss';

class NumberFormatField extends Component {
  state = {
    hasFocus: false,
    startChange: false
  };

  constructor(props) {
    super(props);
    this.input = React.createRef();
  }

  componentDidMount() {
    if (this.props.autofocus) {
      this.input.current.focus();
    }
  }

  render() {
    const {
      name,
      onChange,
      form,
      error,
      childTop,
      disabledTrim,
      hideLabel,
      allowNegative,
      decimalSeparator,
      min,
      max,
      isAllowed,
      ...props
    } = this.props;

    const wrapperClass = classnames({
      'form-group': true
    });

    const inputClass = classnames({
      'form-control': true
    });

    const labelClass = classnames({
      'form-label': true
    });

    const hasError = (error, errors, touched, name) => {
      return error || ( (getIn(touched, name) || this.state.startChange ) && getIn(errors, name));
    };

    return (
      <Field name={name}>
        {({ field, form: { touched, errors, setFieldValue }, handleBlur }) => (
          <div
            className={`${wrapperClass} ${
              hasError(error, errors, touched, field.name) ? 'has-error' : ''
            }`}
          >
            {childTop}
            {
              hideLabel ? '' : (
                <label className={labelClass} htmlFor={this.props.name}>
                  {` ${this.props.label} `}
                </label>
              )
            }
            <NumberFormat
              {...props}
              ref={this.input}
              onChange={e => {
                this.setState({startChange: true})
                field.onChange(e);
                if (onChange) onChange(e);
              }}
              className={inputClass}
              onBlur={e => {
                setFieldValue(field.name, e.target.value);
              }}
              value={field.value}
              name={name}
              allowNegative={allowNegative}
              decimalSeparator={decimalSeparator}
              isAllowed={values =>
                isAllowed ||
                values.value === '' ||
                (values.floatValue <= max && values.floatValue >= min)
              }
            />
            {hasError(error, errors, touched, field.name) && (
              <div className="input-feedback">
                {error || getIn(errors, field.name)}
              </div>
            )}
          </div>
        )}
      </Field>
    );
  }
}

export default NumberFormatField;
